// Copia del serializador de axios 0.19.1 (lib/helpers/buildURL.js). Desde la 0.28, axios manda los
// objetos anidados con corchetes (`filter[a]=1`) en vez de como JSON (`filter={"a":1}`) y codifica
// la `@`. Muchas funciones del crud reenvían `params` que llegan de fuera, así que no se puede
// descartar que alguna mande objetos: se conserva el formato al subir axios por seguridad (TAN-11345).
type Primitive = string | number | boolean | bigint | symbol;

// encodeURIComponent siempre emite los escapes en mayúsculas: basta con reemplazar el literal.
function encode(value: string): string {
  return encodeURIComponent(value)
    .replaceAll('%40', '@')
    .replaceAll('%3A', ':')
    .replaceAll('%24', '$')
    .replaceAll('%2C', ',')
    .replaceAll('%20', '+')
    .replaceAll('%5B', '[')
    .replaceAll('%5D', ']');
}

function stringifyValue(value: unknown): string {
  if (value instanceof Date) {
    return value.toISOString();
  }
  if (value !== null && typeof value === 'object') {
    return JSON.stringify(value);
  }
  return String(value as Primitive);
}

export function serializeAxiosParams(params: Record<string, unknown> | URLSearchParams): string {
  if (params instanceof URLSearchParams) {
    return params.toString();
  }

  const parts: string[] = [];

  for (const [key, value] of Object.entries(params)) {
    if (value === null || value === undefined) {
      continue;
    }

    const isArray = Array.isArray(value);
    const values: unknown[] = isArray ? value : [value];
    const serializedKey = encode(isArray ? `${key}[]` : key);

    for (const item of values) {
      parts.push(`${serializedKey}=${encode(stringifyValue(item))}`);
    }
  }

  return parts.join('&');
}
